import {createEvent} from "effector";

export const changeCurrentCategoryEv = createEvent();

export const changeActiveLayerEv = createEvent()

export const updateGradientByHSEv = createEvent()

export const applyFiltersEv = createEvent()

export const changeABModalEv = createEvent()

export const resetABModalEv = createEvent()

export const changeFilterModalEv = createEvent()

export const resetFilterModalEv = createEvent()
